import script from "./FichaDocumental.vue?vue&type=script&lang=ts&setup=true"
export * from "./FichaDocumental.vue?vue&type=script&lang=ts&setup=true"

import "./FichaDocumental.vue?vue&type=style&index=0&id=646c493d&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-646c493d"]])

export default __exports__